<template>
    <fieldset class="form-group custom-rating-group" :disabled="disabled">
        <legend v-if="label">{{label}}</legend>
        <span class="custom-rating">
            <template v-for="rating in ratings">
                <input type="radio"
                       class="custom-rating-input"
                       :name="'cutomRating' + unique"
                       :id="'cutomRating' + unique + 'Rate' + rating"
                       :value="rating"
                       :checked="value == rating"
                       @click="set(rating)">

                <label class="custom-rating-label"
                       :title="__('rate ') + rating + '/' + max_rating"
                       :for="'cutomRating' + unique + 'Rate' + rating">{{rating}} stars</label>
            </template>
            <input type="hidden" :name="name" :value="value"/>
        </span>
        <!-- The slot should be used to integrate error messages -->
        <slot/>
    </fieldset>
</template>

<script>
    import trans from '../mixins/trans';

    export default {

        mixins: [
            trans
        ],

        props: {
            'name': String,
            'value': null,
            'id': String,
            'label': String,
            'disabled': Boolean,
            'required': Boolean
        },

        data() {
            return {
                unique: null,
                internal_value: null,
                max_rating: 5,
                ratings: [5, 4, 3, 2, 1]
            };
        },

        mounted() {
            this.unique = this._uid;
            this.internal_value = this.value;
        },

        methods: {
            /*
             * Set the rating.
             */
            set(value) {
                if (!this.disabled) {
                    this.$emit('input', value);
                    return this.internal_value = value;
                }
            }
        }

    }
</script>